module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/is-iterable.js
// module id = 335
// module chunks = 0